import data from "../../../../../src/InlineAutocomplete/InlineAutocomplete.docs.json";
import * as React from 'react';
export default {
  data,
  React
};